import * as React from "react";
import { observer } from "mobx-react";
import { useContext, ReactNode } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Switch, Button, InputNumber, Select, Input } from "antd";
import { css, SerializedStyles } from "@emotion/core";
import {
  Pattern,
  newPlans,
  isPlan,
  charms,
  designs,
  sweets,
  Design,
  Sweet,
  Charm,
  i18nSweetShort,
} from "../../stores/ContactViewStore";
// @ts-ignore
import S01 from "../../../img/cover/S01.png";
// @ts-ignore
import P01 from "../../../img/cover/P01.png";
// @ts-ignore
import P02 from "../../../img/cover/P02.png";
// @ts-ignore
import P03 from "../../../img/cover/P03.png";
// @ts-ignore
import P04 from "../../../img/cover/P04.png";
// @ts-ignore
import P05 from "../../../img/cover/P05.png";
// @ts-ignore
import P06 from "../../../img/cover/P06.png";
// @ts-ignore
import P07 from "../../../img/cover/P07.png";
// @ts-ignore
import P08 from "../../../img/cover/P08.png";
// @ts-ignore
import P09 from "../../../img/cover/P09.png";
// @ts-ignore
import P10 from "../../../img/cover/P10.png";
// @ts-ignore
import P11 from "../../../img/cover/P11.png";
// @ts-ignore
import P12 from "../../../img/cover/P12.png";
// @ts-ignore
import P13 from "../../../img/cover/P13.png";
import { Check } from "../atoms/Check";
import {
  checkContainer,
  checkContainer2,
  horizontalScrollContainer,
  selectWithMinWidth,
  hasPriceContainer,
} from "../../style/form";
import { setInputModeForInputNumber } from "../../services/input";

type DesignCellProps = {
  pattern: Pattern;
  design: Design;
  style?: SerializedStyles;
};

const DesignCell = observer(({ pattern, design, style }: DesignCellProps) => {
  const src: string = (() => {
    switch (design) {
      case "S01":
        return S01;
      case "P01":
        return P01;
      case "P02":
        return P02;
      case "P03":
        return P03;
      case "P04":
        return P04;
      case "P05":
        return P05;
      case "P06":
        return P06;
      case "P07":
        return P07;
      case "P08":
        return P08;
      case "P09":
        return P09;
      case "P10":
        return P10;
      case "P11":
        return P11;
      case "P12":
        return P12;
      case "P13":
        return P13;
    }
  })();

  return (
    <div
      onClick={() => {
        pattern.design = design;
      }}
      css={css`
        ${checkContainer}
        ${style || ""}
      `}
    >
      <img src={src} width={100} />
      <Check checked={pattern.design === design} />
    </div>
  );
});

const HasPriceCell = <A extends Sweet | Charm>(
  key: string,
  getLabel: (a: A) => ReactNode
) =>
  observer(({ pattern, obj, style }) => {
    return (
      <div
        css={css`
          ${hasPriceContainer}
          ${style || ""}
        `}
      >
        <div
          onClick={() => {
            pattern[key] = obj;
          }}
          css={css`
            ${checkContainer2}
          `}
        >
          <img src={obj.src} width={100} />
          <Check checked={pattern[key] === obj} />
        </div>
        <div
          css={css`
            margin-right: 25px;
            font-size: 12px;
            display: flex;
            flex-direction: column;
          `}
        >
          <div
            css={css`
              align-self: center;
            `}
          >
            {getLabel(obj)}
          </div>
          <div
            css={css`
              display: flex;
              align-self: center;
            `}
          >
            <div
              css={
                obj.listPrice != obj.price &&
                css`
                  text-decoration: line-through;
                `
              }
            >
              &yen;{obj.listPrice}
            </div>
            {obj.listPrice != obj.price && (
              <div
                css={css`
                  color: #f15949;
                  padding-left: 5px;
                `}
              >
                &yen;{obj.price}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  });

const SweetCell = HasPriceCell("sweet", (x: Sweet) => i18nSweetShort(x.code));

const CharmCell = HasPriceCell("charm", (x: Charm) =>
  x.name === "めでタイすだち" ? (
    <>
      {x.name}
      <br />
      (夏期納品不可)
    </>
  ) : (
    x.name
  )
);

type PatternCellProps = {
  index: number;
  pattern: Pattern;
  extended: boolean;
};

const PatternCell = observer(
  ({ index, pattern, extended }: PatternCellProps) => {
    const store = useContext(ContactViewStoreContext);

    return (
      <div
        css={css`
          box-shadow: 0 1px 4px rgba(102, 29, 48, 0.2);
          border-radius: 20px;
          padding: 15px;
          margin-bottom: 20px;
        `}
      >
        {store.usePatterns && <h3>贈り分けパターン{index + 1}</h3>}
        <div
          css={css`
            margin-bottom: 24px;
          `}
        >
          <h4>個数</h4>
          <InputNumber
            min={0}
            value={pattern.amount}
            ref={setInputModeForInputNumber("numeric")}
            onChange={(e) => {
              pattern.amount = e;
            }}
          />
        </div>
        <div
          css={css`
            margin-bottom: 24px;
          `}
        >
          <h4>引き出物:カタログギフト(6プラン)</h4>
          <Select
            css={selectWithMinWidth}
            value={pattern.plan}
            onChange={(value: any) => {
              if (!isPlan(value)) return;
              pattern.plan = value;
            }}
          >
            {newPlans.map((p, i) => (
              <Select.Option key={i} value={p}>
                {p}
              </Select.Option>
            ))}
          </Select>
        </div>
        {extended && (
          <div
            css={css`
              margin-bottom: 24px;
            `}
          >
            <h4>カタログギフトのデザイン(14パターン)</h4>
            <div
              css={css`
                ${horizontalScrollContainer}
                margin-left: -35px;
                margin-right: -35px;

                @media (min-width: 576px) {
                  margin-left: -65px;
                  margin-right: -65px;
                }

                @media (min-width: 768px) {
                  margin-left: 0;
                  margin-right: 0;
                }
              `}
            >
              {designs.map((d, i) => (
                <DesignCell
                  key={i}
                  pattern={pattern}
                  design={d}
                  style={
                    i === 0
                      ? css`
                          margin-left: 35px;

                          @media (min-width: 576px) {
                            margin-left: 65px;
                          }

                          @media (min-width: 768px) {
                            margin-left: 0;
                          }
                        `
                      : undefined
                  }
                />
              ))}
            </div>
            <h4
              css={css`
                margin-top: 24px;
              `}
            >
              引き菓子バウムクーヘン (7種)
            </h4>
            <div
              css={css`
                ${horizontalScrollContainer}
                margin-left: -35px;
                margin-right: -35px;

                @media (min-width: 576px) {
                  margin-left: -65px;
                  margin-right: -65px;
                }

                @media (min-width: 768px) {
                  margin-left: 0;
                  margin-right: 0;
                }
              `}
            >
              {sweets.map((x, i) => (
                <SweetCell
                  key={i}
                  pattern={pattern}
                  obj={x}
                  style={
                    i === 0
                      ? css`
                          margin-left: 35px;

                          @media (min-width: 576px) {
                            margin-left: 65px;
                          }

                          @media (min-width: 768px) {
                            margin-left: 0;
                          }
                        `
                      : undefined
                  }
                />
              ))}
            </div>
          </div>
        )}
        {extended && (
          <div
            css={css`
              margin-bottom: 24px;
            `}
          >
            <h4>縁起物</h4>
            <div
              css={css`
                ${horizontalScrollContainer}
                margin-left: -35px;
                margin-right: -35px;

                @media (min-width: 576px) {
                  margin-left: -65px;
                  margin-right: -65px;
                }

                @media (min-width: 768px) {
                  margin-left: 0;
                  margin-right: 0;
                }
              `}
            >
              {charms.map((x, i) => (
                <CharmCell
                  key={i}
                  pattern={pattern}
                  obj={x}
                  style={
                    i === 0
                      ? css`
                          margin-left: 35px;

                          @media (min-width: 576px) {
                            margin-left: 65px;
                          }

                          @media (min-width: 768px) {
                            margin-left: 0;
                          }
                        `
                      : undefined
                  }
                />
              ))}
            </div>
            <div
              css={css`
                margin-top: 24px;
                margin-bottom: 24px;
              `}
            >
              <Input.TextArea
                rows={4}
                placeholder="備考"
                value={pattern.comment}
                onChange={(e) => {
                  pattern.comment = e.target.value;
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
);

type Props = {
  extended: boolean;
};

export const PatternEditor = observer(({ extended }: Props) => {
  const store = useContext(ContactViewStoreContext);

  return (
    <div>
      <div
        css={css`
          margin-bottom: 24px;
        `}
      >
        <h4>贈り分けをする</h4>
        <Switch
          checked={store.usePatterns}
          onChange={(e) => {
            store.usePatterns = e;
          }}
        />
      </div>
      <div
        css={css`
          margin-bottom: 30px;
        `}
      >
        {store.availablePatterns.map((p, i) => (
          <PatternCell key={i} pattern={p} index={i} extended={extended} />
        ))}
        {store.usePatterns && store.patterns.length < 4 && (
          <Button
            onClick={() => {
              store.addPattern();
            }}
          >
            + 贈り分けパターン{store.patterns.length + 1}を記入
          </Button>
        )}
      </div>
    </div>
  );
});
